import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Home from '../containers/Home';
import NotFound from '../containers/NotFound';
import Layout from '../components/Layout';
import '../assets/styles/App.scss';
import reCaptchaConfig from '../config/reCaptchaConfig';

const App = () => {
    React.useEffect(()=> {
      // Add reCaptcha
      const script = document.createElement("script");
      script.src = "https://www.google.com/recaptcha/api.js?render="+reCaptchaConfig.siteKey;
      //script.addEventListener("load", handleLoaded);
      document.body.appendChild(script);
    }, []);
    
    return(
        <BrowserRouter>
            <Layout>  
                <Switch>
                    <Route exact path="/" component={Home}/>
                    <Route exact path="/chelas-gratis" component={Home}/>
                    <Route component={NotFound} />
                </Switch>
            </Layout>
        </BrowserRouter>
    );
};




export default App;
